module.exports = __webpack_public_path__ + "static/img/inventario_tractocamiones.8f308ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/inventario_tractocamiones.png
// module id = 98
// module chunks = 0